module.exports = __webpack_public_path__ + "img/greenLife.c1d8ea2f.svg";